const rtf = new Intl.RelativeTimeFormat('en-GB', { numeric: 'auto' });

/** "4 min ago" for the queue; absolute date once it stops being recent —
 *  a queue full of "3 weeks ago" is less useful than the date. */
export function relativeTime(epochMs: number): string {
  const diff = epochMs - Date.now();
  const abs = Math.abs(diff);
  if (abs < 60_000) return 'just now';
  if (abs < 3_600_000) return rtf.format(Math.round(diff / 60_000), 'minute');
  if (abs < 86_400_000) return rtf.format(Math.round(diff / 3_600_000), 'hour');
  if (abs < 7 * 86_400_000) return rtf.format(Math.round(diff / 86_400_000), 'day');
  return new Date(epochMs).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function fullTime(epochMs: number): string {
  return new Date(epochMs).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' });
}
